export enum ProductType2 {
  DIGITAL = 'DIGITAL',
  PHYSICAL = 'PHYSICAL',
  SUBSCRIPTION = 'SUBSCRIPTION'
}
